import React, { useEffect, useState } from 'react';
import { useApp } from '../AppContext';

const NAV = [
  { href: '#approccio', label: 'Approccio' },
  { href: '#servizi', label: 'Servizi' },
  { href: '#faq', label: 'Domande' },
  { href: '#prenota', label: 'Prenota' },
];

export default function Header() {
  const { requestDashboard } = useApp();
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  // Close the mobile menu with Escape
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') setOpen(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  return (
    <header id="site-header" className="sticky top-0 z-40 bg-beigeBG/95 backdrop-blur-md border-b border-forest/10 smooth-transition">
      <div className="header-inner max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <a href="#inizio" onClick={close} className="flex items-center gap-2.5 sm:gap-3 group min-w-0">
          <img
            src={`${process.env.PUBLIC_URL}/logo-mark.webp`}
            alt="Logo Dr. Michele Balducci"
            width={343}
            height={295}
            className="h-10 sm:h-12 w-auto shrink-0 smooth-transition group-hover:scale-105"
          />
          <span className="flex flex-col leading-none min-w-0">
            <span className="font-serif text-xl sm:text-2xl font-semibold tracking-tight text-forestDark truncate">Dr. Michele Balducci</span>
            <span className="text-[0.65rem] sm:text-xs tracking-[0.2em] uppercase text-sage font-medium mt-1 truncate">Psicologo &amp; Psicoterapeuta</span>
          </span>
        </a>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center space-x-10 text-sm font-medium">
          {NAV.map((n) => (
            <a key={n.href} href={n.href} className="nav-link text-charcoal hover:text-forest smooth-transition">{n.label}</a>
          ))}
        </nav>

        {/* Desktop actions */}
        <div className="hidden md:flex items-center space-x-4">
          <button
            onClick={requestDashboard}
            className="inline-flex items-center space-x-2 text-xs uppercase tracking-wider text-sage hover:text-forest font-semibold border border-sage/30 hover:border-forest/50 px-4 py-2 rounded-full smooth-transition"
          >
            <span>Area Riservata</span>
          </button>

          <a href="#prenota" className="btn-shine bg-forest hover:bg-forestDark text-cream px-6 py-2.5 rounded-full text-sm font-medium shadow-md hover:shadow-lg smooth-transition">
            Primo colloquio gratuito
          </a>
        </div>

        {/* Mobile hamburger */}
        <button
          type="button"
          onClick={() => setOpen((o) => !o)}
          aria-label={open ? 'Chiudi menu' : 'Apri menu'}
          aria-expanded={open}
          aria-controls="mobile-menu"
          className="md:hidden inline-flex items-center justify-center w-11 h-11 -mr-2 rounded-lg text-forestDark hover:bg-forest/5 smooth-transition"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24">
            {open ? (
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 6l12 12M18 6L6 18" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 7h16M4 12h16M4 17h16" />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile menu panel */}
      <div
        id="mobile-menu"
        className={`md:hidden overflow-hidden bg-beigeBG/98 backdrop-blur-md transition-[max-height] duration-300 ease-out ${open ? 'max-h-96 border-t border-forest/10' : 'max-h-0'}`}
      >
        <nav className="max-w-7xl mx-auto px-6 py-4 flex flex-col text-base font-medium">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              onClick={close}
              className="py-2.5 text-charcoal hover:text-forest smooth-transition border-b border-forest/5 last:border-0"
            >
              {n.label}
            </a>
          ))}
          <a
            href="#prenota"
            onClick={close}
            className="btn-shine mt-4 text-center bg-forest hover:bg-forestDark text-cream px-6 py-3 rounded-full text-sm font-medium shadow-md smooth-transition"
          >
            Primo colloquio gratuito
          </a>
          <button
            onClick={() => { close(); requestDashboard(); }}
            className="mt-2 text-center text-xs uppercase tracking-wider text-sage hover:text-forest font-semibold border border-sage/30 hover:border-forest/50 px-4 py-2.5 rounded-full smooth-transition"
          >
            Area Riservata
          </button>
        </nav>
      </div>
    </header>
  );
}
